import { Injectable } from '@angular/core';
import { fabric } from 'fabric';
import { TranslateService } from '@ngx-translate/core';
import { SignatureImageUtils } from './signature-image.utils';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { CanvasTypeEnum } from 'src/app/enum/canvas-type.enum';

const FULL_NAME_CANVAS = 'fullNameCanvas';
const PERSONAL_ID_CANVAS = 'personalIdCanvas';
const SIGNATURE_CANVAS = 'signatureCanvas';
const DATE_CANVAS = 'dateCanvas';

@Injectable({
  providedIn: 'root'
})
export class SignatureCanvasUtils {

  backgroundImage = SignatureImageUtils.backgroundImage;

  defaultLetfOffset = 55;
  defaultFontFamily = 'Arial';
  defaultFontStyle = 'italic';
  defaultFontSize = 16;
  defaultFillColor = '#666666';
  canvasSize = { width: 720, height: 175 };
  rubricSize = { width: 250, height: 125 };

  signatureFontSize = 45;

  fontFamily = 'Aguafina Script';
  defaultMobileFontSize = 14;

  canvasSizeSignatory = { width: 300, height: 150 };
  canvasSizeRubric = { width: 300, height: 150 };
  canvasParamsRubric = { topOffset: 110, fontTopOffset: 40, fontSize: 12, personalIdTopOffSet: 95, defaultLetfOffset: 40 };
  canvasParamsSignature = { topOffset: 155, fontTopOffset: 55, fontSize: 16, personalIdTopOffSet: 135, defaultLetfOffset: 55 };
  signatoryLetfOffset = 40;
  signatoryFontFamilySignatory = 'Arial';
  signatoryFontStyleSignatory = 'normal';
  signatoryFontSizeSignatory = 16;
  signatoryfontTopOffset = 14;
  signatoryFontSizeRubric = 72;


  private canvas: any;

  constructor(private translate: TranslateService) { }

  public newCanvas(params) {
    const canvasParams = {
      hoverCursor: 'pointer',
      selection: true,
      selectionBorderColor: 'blue',
      isDrawingMode: undefined,
      imageOverlay: undefined
    };

    if (params.isDrawingMode) {
      canvasParams.isDrawingMode = params.isDrawingMode;
    }

    this.canvas = new fabric.Canvas(params.canvasId, canvasParams);
    if (params.imageOverlay) {
      this.canvas.setOverlayImage(params.imageOverlay, this.canvas.renderAll.bind(this.canvas));
    }

    this.canvas.setWidth(this.canvasSize.width);
    this.canvas.setHeight(this.canvasSize.height);

    return this.canvas;
  }

  public newCanvasRubricSignature(params) {
    const canvasParams = {
      hoverCursor: 'pointer',
      selection: true,
      selectionBorderColor: 'blue',
      isDrawingMode: undefined,
      imageOverlay: undefined
    };

    if (params.isDrawingMode) {
      canvasParams.isDrawingMode = params.isDrawingMode;
    }

    this.canvas = new fabric.Canvas(params.canvasId, canvasParams);
    if (params.imageOverlay) {
      this.canvas.setOverlayImage(params.imageOverlay, this.canvas.renderAll.bind(this.canvas));
    }

    this.canvas.setWidth(this.rubricSize.width);
    this.canvas.setHeight(this.rubricSize.height);

    return this.canvas;
  }

  public newCanvasSignatory(params) {
    const canvasParams = {
      hoverCursor: 'pointer',
      selection: true,
      selectionBorderColor: 'blue',
      isDrawingMode: undefined,
      imageOverlay: undefined
    };

    if (params.isDrawingMode) {
      canvasParams.isDrawingMode = params.isDrawingMode;
    }

    this.canvas = new fabric.Canvas(params.canvasId, canvasParams);
    if (params.imageOverlay) {
      this.canvas.setOverlayImage(params.imageOverlay, this.canvas.renderAll.bind(this.canvas));
    }

    this.canvas.setWidth(this.canvasSizeSignatory.width);
    this.canvas.setHeight(this.canvasSizeSignatory.height);

    return this.canvas;
  }

  public newCanvasRubric(params) {
    const canvasParams = {
      hoverCursor: 'pointer',
      selection: true,
      selectionBorderColor: 'blue',
      isDrawingMode: undefined,
      imageOverlay: undefined
    };

    if (params.isDrawingMode) {
      canvasParams.isDrawingMode = params.isDrawingMode;
    }

    this.canvas = new fabric.Canvas(params.canvasId, canvasParams);
    if (params.imageOverlay) {
      this.canvas.setOverlayImage(params.imageOverlay, this.canvas.renderAll.bind(this.canvas));
    }

    this.canvas.setWidth(this.canvasSizeRubric.width);
    this.canvas.setHeight(this.canvasSizeRubric.height);

    return this.canvas;
  }

  public addBackgroundToCanvas(canvas, params) {
    return new Promise<void>(function (resolve, reject) {
      const imgObj = new Image();
      imgObj.onload = function () {
        const f_img = new fabric.Image(imgObj);
        const scale = (canvas.getHeight() / f_img.height) * 1.0;
        f_img.set({
          left: 0,
          top: 0,
          angle: 0,
          padding: 10,
          cornersize: 10,
          hasRotatingPoint: true,
          peloas: 12,
          scaleX: scale,
          scaleY: scale,
        });
        canvas.setBackgroundImage(f_img);
        canvas.renderAll();
        resolve();
      };
      imgObj.src = params.image;
    });
  }

  public addBackgroundSignatoryToCanvas(canvas, params) {
    return new Promise<void>(function (resolve, reject) {
      const imgObj = new Image();
      imgObj.onload = function () {
        const f_img = new fabric.Image(imgObj);
        const scale = (canvas.getHeight() / f_img.height) * 1.0;
        f_img.set({
          left: 2,
          top: 2,
          angle: 0,
          padding: 0,
          cornersize: 0,
          hasRotatingPoint: true,
          peloas: 12,
          scaleX: scale,
          scaleY: scale,
        });
        canvas.setBackgroundImage(f_img);
        canvas.renderAll();
        resolve();
      };
      imgObj.src = params.image;
    });
  }

  public addTextDate(canvasType: CanvasTypeEnum, canvas, value) {
    const canvasParams = this.canvasType(canvasType);
    this.addTextToCanvas(canvas, {
      text: value,
      leftOffset: canvasParams.defaultLetfOffset,
      topOffset: 21,
      fontFamily: this.defaultFontFamily,
      fontStyle: this.defaultFontStyle,
      fontSize: this.defaultFontSize,
      fixed: '',
      fillColor: this.defaultFillColor,
      component: DATE_CANVAS
    });
  }

  public addTextDateRubric(canvasType: CanvasTypeEnum, canvas, value) {
    const canvasParams = this.canvasType(canvasType);
    this.addTextToCanvas(canvas, {
      text: value,
      leftOffset: canvasParams.defaultLetfOffset,
      topOffset: 21,
      fontFamily: this.defaultFontFamily,
      fontStyle: this.defaultFontStyle,
      fontSize: 12,
      fixed: '',
      fillColor: this.defaultFillColor,
      component: DATE_CANVAS
    });
  }

  addTextTitle(canvasType: CanvasTypeEnum, canvas, value) {
    const canvasParams = this.canvasType(canvasType);
    this.addTextToCanvas(canvas, {
      text: value,
      leftOffset: canvasParams.defaultLetfOffset,
      topOffset: 0,
      fontFamily: this.defaultFontFamily,
      fontStyle: this.defaultFontStyle,
      fontSize: this.defaultFontSize,
      fixed: true,
      fillColor: this.defaultFillColor,
    });
  }

  public addTextFullName(canvasType: CanvasTypeEnum, canvas, value) {
    const canvasParams = this.canvasType(canvasType);
    this.addTextToCanvas(canvas, {
      text: `${value}`,
      leftOffset: canvasParams.defaultLetfOffset,
      topOffset: canvasParams.topOffset,
      fontFamily: this.defaultFontFamily,
      fontStyle: this.defaultFontStyle,
      fontSize: this.defaultFontSize,
      fillColor: this.defaultFillColor,
      component: FULL_NAME_CANVAS
    });
  }

  public addTextPersonal(canvasType, canvas, isCpf, show, value) {
    const canvasParams = this.canvasType(canvasType);
    if (show) {
      this.addTextToCanvas(canvas, {
        text: `${this.translate.instant(isCpf ? 'cpf' : 'cnpj')}: ${CPFCNPJUtil.formatSssnWithSpecifcMask(value, isCpf)}`,
        leftOffset: canvasParams.defaultLetfOffset,
        topOffset: canvasParams.personalIdTopOffSet,
        fontFamily: this.defaultFontFamily,
        fontStyle: this.defaultFontStyle,
        fontSize: canvasParams.fontSize,
        fillColor: this.defaultFillColor,
        component: PERSONAL_ID_CANVAS
      });
    }
  }

  public addTextSignature(canvasType: CanvasTypeEnum, canvas, value, fontSize) {
    const canvasParams = this.canvasType(canvasType);
    this.addTextToCanvas(canvas, {
      text: `${value}`,
      leftOffset: canvasParams.defaultLetfOffset,
      topOffset: canvasParams.fontTopOffset,
      fontFamily: this.fontFamily,
      fontStyle: this.defaultFontStyle,
      fontSize: fontSize,
      fillColor: '#000000',
      component: SIGNATURE_CANVAS
    });
  }

  public addTextTitleSignatory(canvas, value, topOffset: number) {
    this.addTextToCanvas(canvas, {
      text: value,
      leftOffset: this.signatoryLetfOffset,
      topOffset: topOffset,
      fontFamily: this.defaultFontFamily,
      fontStyle: this.defaultFontStyle,
      fontSize: this.signatoryFontSizeSignatory,
      fixed: true,
      fillColor: this.defaultFillColor,
    });
  }

  public addTextTitleRubric(canvas, value) {
    this.addTextToCanvas(canvas, {
      text: value,
      leftOffset: 40,
      topOffset: 1,
      fontFamily: this.defaultFontFamily,
      fontStyle: this.defaultFontStyle,
      fontSize: 38,
      fixed: true,
      fillColor: this.defaultFillColor,
    });
  }

  public addTextDateSignatory(canvas, value) {
    this.addTextToCanvas(canvas, {
      text: value,
      leftOffset: this.signatoryLetfOffset,
      topOffset: 12,
      fontFamily: this.defaultFontFamily,
      fontStyle: this.defaultFontStyle,
      fontSize: this.signatoryFontSizeSignatory,
      fixed: '',
      fillColor: this.defaultFillColor,
      component: DATE_CANVAS
    });
  }

  public addTextRubric(canvas, value) {
    this.addTextSignatoryRubricToCanvas(canvas, {
      text: `${value}`,
      leftOffset: 55,
      topOffset: 40,
      fontFamily: 'Segoe Script',
      fontStyle: this.signatoryFontStyleSignatory,
      fontSize: this.signatoryFontSizeRubric,
      fillColor: '#000000',
      component: SIGNATURE_CANVAS
    });
  }

  public addTextSignatory(canvas, value) {
    this.addTextSignatoryToCanvas(canvas, {
      text: `${value}`,
      leftOffset: 40,
      topOffset: 65,
      fontFamily: this.signatoryFontFamilySignatory,
      fontStyle: this.signatoryFontStyleSignatory,
      fontSize: this.signatoryFontSizeSignatory,
      fillColor: '#000000',
      component: SIGNATURE_CANVAS
    });
  }

  public addTextPersonalSignatory(canvas, isCpf, show, value) {
    if (show) {
      this.addTextToCanvas(canvas, {
        text: `${this.translate.instant(isCpf ? 'cpf' : 'cnpj')}: ${CPFCNPJUtil.formatSssnWithSpecifcMask(value, isCpf)}`,
        leftOffset: this.signatoryLetfOffset,
        topOffset: 55,
        fontFamily: this.defaultFontFamily,
        fontStyle: this.defaultFontStyle,
        fontSize: this.signatoryFontSizeSignatory,
        fillColor: this.defaultFillColor,
        component: PERSONAL_ID_CANVAS
      });
    }
  }

  public addTextFullNameSignatory(canvas, value) {
    this.addTextToCanvas(canvas, {
      text: `${value}`,
      leftOffset: this.signatoryLetfOffset,
      topOffset: 125,
      fontFamily: this.defaultFontFamily,
      fontStyle: this.defaultFontStyle,
      fontSize: this.signatoryFontSizeSignatory,
      fillColor: this.defaultFillColor,
      component: FULL_NAME_CANVAS
    });
  }

  public addTextToCanvas(canvas, params) {
    const textParams = {
      left: params.leftOffset,
      top: params.topOffset,
      fontFamily: params.fontFamily,
      angle: 0,
      fill: params.fillColor,
      fontSize: params.fontSize,
      lineHeight: 1,
      scaleX: 1,
      scaleY: 1,
      fontWeight: '',
      selectable: false,
      hasRotatingPoint: false,
      fontStyle: '',
      fixed: true,
      component: params.component
    };

    if (params.fontStyle) {
      textParams.fontStyle = params.fontStyle;
    }
    if (params.fixed) {
      textParams.fixed = params.fixed;
    }

    const text = new fabric.IText(params.text, textParams);
    canvas.add(text);
    canvas.renderAll();
  }

  public addTextSignatoryToCanvas(canvas, params) {
    const textParams = {
      left: params.leftOffset,
      top: params.topOffset,
      fontFamily: params.fontFamily,
      angle: 0,
      fill: params.fillColor,
      fontSize: params.fontSize,
      lineHeight: 1,
      scaleX: 1,
      scaleY: 1,
      fontWeight: '',
      selectable: false,
      hasRotatingPoint: false,
      fontStyle: '',
      fixed: true,
      component: params.component
    };

    if (params.fontStyle) {
      textParams.fontStyle = params.fontStyle;
    }
    if (params.fixed) {
      textParams.fixed = params.fixed;
    }

    const text = new fabric.IText(params.text, textParams);
    const rect = new fabric.Rect({
      left: this.signatoryLetfOffset,
      top: 67,
      width: 170,
      height: 17,
      fill: '#F0F0F0',
      opacity: 0.5
    });
    const group = new fabric.Group([rect, text]);
    canvas.add(group);
    canvas.renderAll();
  }

  public addTextSignatoryRubricToCanvas(canvas, params) {
    const textParams = {
      left: params.leftOffset,
      top: params.topOffset,
      fontFamily: params.fontFamily,
      angle: 0,
      fill: params.fillColor,
      fontSize: params.fontSize,
      lineHeight: 1,
      scaleX: 1,
      scaleY: 1,
      fontWeight: '',
      selectable: false,
      hasRotatingPoint: false,
      fontStyle: '',
      fixed: true,
      component: params.component
    };

    if (params.fontStyle) {
      textParams.fontStyle = params.fontStyle;
    }
    if (params.fixed) {
      textParams.fixed = params.fixed;
    }

    const text = new fabric.IText(params.text, textParams);
    const rect = new fabric.Rect({
      left: 45,
      top: 40,
      width: 150,
      height: 80,
      fill: '#F0F0F0',
      opacity: 0.5
    });
    const group = new fabric.Group([rect, text]);
    canvas.add(group);
    canvas.renderAll();
  }

  public addImageToCanvas(canvas, params) {
    return new Promise<any>(function (resolve, reject) {
      const imgObj = new Image();
      imgObj.onload = x => {
        const f_img = new fabric.Image(imgObj);
        const scale = (((params.mask && params.mask.height) ? params.mask.height : canvas.getHeight())
          / f_img.height) * params.scale;

        const imgParams = {
          left: ((params.mask && params.mask.leftOffset) ? params.mask.leftOffset : 0),
          top: ((params.mask && params.mask.topOffset) ? params.mask.topOffset : 0),
          angle: 0,
          padding: 0,
          cornersize: 10,
          hasRotatingPoint: true,
          peloas: 12,
          scaleX: scale,
          scaleY: scale,
          activeObject: true,
          clipName: 'clipName',
          clipTo: undefined,
          clipRect: undefined
        };

        if (params.mask) {
          imgParams.clipName = 'clipName';
          imgParams.clipTo = function (ctx) {
            ctx.save();
            ctx.setTransform(canvas.getRetinaScaling(), 0, 0, canvas.getRetinaScaling(), 0, 0);
            this.clipRect.transform(ctx);
            this.clipRect._render(ctx);
            ctx.restore();
          };

          const rectParams = {
            originX: 'left',
            originY: 'top',
            fill: '',
            stroke: 'black',
            strokeWidth: 0,
            selectable: false,
            objectCaching: false,
            left: undefined,
            top: undefined,
            width: undefined,
            height: undefined
          };

          if (params.mask.leftOffset) {
            rectParams.left = params.mask.leftOffset;
          }

          if (params.mask.topOffset) {
            rectParams.top = params.mask.topOffset;
          }

          if (params.mask.width) {
            rectParams.width = params.mask.width;
          }

          if (params.mask.height) {
            rectParams.height = params.mask.height;
          }

          imgParams.clipRect = new fabric.Rect(rectParams);
        }

        f_img.set(imgParams);
        canvas.add(f_img);
        canvas.renderAll();
        resolve(canvas);
      };
      imgObj.src = params.image;
    });
  }

  public selectObjects(canvas) {
    canvas.getObjects().forEach(function (item) {
      if (!item.fixed) {
        canvas.setActiveObject(item);
      }
    });
  }

  public exportCanvasAsImage(canvas, params) {
    return canvas.toDataURL(params.format);
  }

  public clearCanvas(canvas) {
    if (canvas.getObjects().length <= 0) {
      return;
    }

    canvas.getObjects().forEach(function (item) {
      canvas.remove(item);
    });
  }

  public clearSpecificCanvas(components, canvas) {
    canvas.getObjects().forEach(function (item) {
      if (components.includes(item.component)) {
        canvas.remove(item);
      }
    });
  }

  public exportImageAndAddToHtmlPageElementWithOpacity(canvas, elementId, opacity) {
    const image = this.exportCanvasAsImage(canvas, { format: 'jpg' });

    const img = document.createElement('img');
    img.src = image;
    img.style.opacity = opacity;

    const src = document.getElementById(elementId);
    if (src != undefined) {
      src.innerHTML = '';
      src.appendChild(img);
    }

  }

  exportImageAndAddToHtmlPageElement(canvas, elementId) {
    this.exportImageAndAddToHtmlPageElementWithOpacity(canvas, elementId, '1.0');
  }

  public isCanvasEmpty(canvas) {
    let result = true;
    canvas.getObjects().forEach(function (item) {
      if (!item.fixed) {
        result = false;
      }
    });
    return result;
  }

  private canvasType(canvasType: CanvasTypeEnum) {
    if (canvasType === CanvasTypeEnum.rubric) {
      return this.canvasParamsRubric;
    }
    return this.canvasParamsSignature;
  }
}
